import React from 'react';
import styled, { css } from 'styled-components';

import { Color } from '@/theme';
import { T } from '@/ui/Text/Text';

type Props = {
  readonly color: Color;
  readonly icon?: React.ReactNode;
  readonly children?: React.ReactNode;
  readonly narrow?: boolean;
  readonly onClick?: () => void;
};

const StyledWrapper = styled.div.attrs(({ color }: Props) => ({
  style: { backgroundColor: color },
}))<Props>`
  display: inline-flex;
  align-items: center;
  padding: 4px 16px;
  border-radius: 40px;
  min-height: 26px;
  height: auto;

  ${({ narrow }) =>
    narrow &&
    css`
      padding-left: 8px;
      padding-right: 8px;
    `}
`;

export const Tag = ({ narrow, color, children, icon, onClick }: Props) => (
  <StyledWrapper color={color} narrow={narrow} onClick={onClick}>
    <T body2>{children}</T>
    {icon}
  </StyledWrapper>
);
